const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
    minWidth: 800,
  },
});

export default styles;
